/**
 * Clamps a number between two values.
 *
 * Samples:
 *      { value = -5, minimum = 0, maximum = 10 } => 0
 *      { value =  5, minimum = 0, maximum = 10 } => 5
 *      { value = 15, minimum = 0, maximum = 10 } => 10
 */
export const clamp = (value: number, minimum: number, maximum: number) => Math.max(minimum, Math.min(value, maximum));
